import Contract from "./Contract";

const Index = () => {

    
    return (
        <>
            <Contract title={"Sales Proceed Due"} settlementType={"4"}/>
        </>
    );
};

export default Index;
